import React, { useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { auth, db } from './firebase'

function Bannerjee() {

    const nameRef = useRef()
    const [loading, setLoading] = useState()

    return (
        <div>
            <form className="d-flex align-items-center flex-column">
                <textarea placeholder="Enter participants name"  rows ={20} className="w-50 my-2 p-2" ref={nameRef}/>
    
                
                <button class="learn-more">

                            {loading?(
                                            <Spinner variant="light" animation="border" role="status">
                                           
                                          </Spinner>):(
                                            <>
                                             <span  class="circle" aria-hidden="true">
                                <span class="icon arrow"></span>
                                </span>
                                <span class="button-text">Register Now</span>
                                            </>
                                        )}
                            </button>
            </form>
        </div>
    )
}

export default Bannerjee
